import * as types from './types'
export default {
  [types.SET_TRANSLATIONS](state, translations) {
    state.translations = translations
    for (const item of state.translations) {
      item.isTranslated = false
    }
  },
  [types.SET_SERVICE_ELEMENT_TRANSLATIONS](state, translations) {
    state.serviceElementTranslations = translations
    for (const item of state.serviceElementTranslations) {
      item.isTranslated = false
    }
  },
  [types.SET_TRANSLATION](state, data) {
    for (const item of state.translations) {
      if (item.applyTo === data.applyTo && item.name === data.name) {
        item.translation = data.translation
        item.isTranslated = true
        break
      }
    }
  },
  [types.SET_SERVICE_ELEMENT_TRANSLATION](state, data) {
    for (const item of state.serviceElementTranslations) {
      if (item.serviceElementId === data.serviceElementId) {
        item.translation = data.translation
        item.isTranslated = true
        break
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/translation/mutations.js